export const SET_SKETCH_ID = 'SET_SKETCH_ID';
export const SET_MEASUREMENT_ID = 'SET_MEASUREMENT_ID';
export const SET_PM_AND_PID = 'SET_PM_AND_PID';
export const SET_OBJECT_GEOMETRY_DATA = 'SET_OBJECT_GEOMETRY_DATA';
export const SET_OBJECT_GEOMETRY_DATA_BEGIN = 'SET_OBJECT_GEOMETRY_DATA_BEGIN';
export const SET_OBJECT_GEOMETRY_DATA_SUCCESS =
  'SET_OBJECT_GEOMETRY_DATA_SUCCESS';
export const SET_OBJECT_GEOMETRY_DATA_FAILED =
  'SET_OBJECT_GEOMETRY_DATA_FAILED';
